import { OrganizationsStudents } from "@/pages/medewerkers/$organizationUserId/students/OrganizationStudents"
import { checkOrganizationPermissions } from "@/utils/checkOrganizationPermissions"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/beheer/medewerkers/$organizationUserId/gekoppelde-cursisten/",
)({
  component: RouteComponent,
  beforeLoad: () => checkOrganizationPermissions("read", "contacts"),
})

function RouteComponent() {
  const { organizationUserId } = useParams({
    from: "/beheer/medewerkers/$organizationUserId",
  })

  return (
    <OrganizationsStudents organizationUserId={Number(organizationUserId)} />
  )
}
